'use client'

import CreationToolCutOutMode from 'creation/src/creation-tools/types/cut-out-mode'
import { cn } from '@/util/cn'
import { gridBlock } from '../../presentation/blocks'
import { cutOutModeColor, cutOutModeHoverColor } from '../../presentation/cut-out-mode'
import { subtitle } from '../../presentation/typography'
import { useCutOut } from './cut-out-context'
import { ToolConfig } from './pen-size-tool'
import ToolIcon from './tool-icon'

// Port of cut-out/buttons.tsx:52-104. The 2x2 grid of tool buttons that
// selects between Lasso/Brush/Magic Wand/Eraser, plus the pen-size panel for
// whichever tool is active underneath it.
const CutOutButtons = () => {
    const { mode: activeMode, setMode, setModeInstructionPreview, isBrushEnabled } = useCutOut()

    return (
        <div className="my-[30px]">
            <h3 className={subtitle}>Tools</h3>
            <div className={gridBlock(2)}>
                {CreationToolCutOutMode.all().map((mode) => {
                    const isActive = mode === activeMode
                    const isAvailable = mode !== CreationToolCutOutMode.Paint || isBrushEnabled
                    const title = CreationToolCutOutMode.title(mode)
                    return (
                        <div
                            key={mode}
                            data-testid={`tool-${mode}`}
                            data-disabled={String(!isAvailable)}
                            // Legacy relies solely on `pointer-events: none` to block the
                            // click (components/buttons.ts:15-20); this `isAvailable` guard
                            // is inert in a real browser and exists only because jsdom does
                            // not enforce CSS pointer-events on a dispatched event.
                            onClick={() => isAvailable && setMode(mode)}
                            className={cn(
                                'relative cursor-pointer rounded-[4px] transition-[background-color,color] duration-200 ease-out select-none active:opacity-80',
                                isActive ? cn(cutOutModeColor(mode), 'text-black') : 'bg-black text-white',
                                'hover:text-black',
                                cutOutModeHoverColor(mode),
                                !isAvailable && 'pointer-events-none opacity-25'
                            )}
                        >
                            <ToolIcon mode={mode} isActive={isActive} />
                            <span
                                className={cn(
                                    subtitle,
                                    'pointer-events-none absolute bottom-[15px] left-0 m-0 box-border w-full px-[10px] text-center'
                                )}
                            >
                                {title}
                            </span>
                            {isAvailable && (
                                <div
                                    className="ss-info absolute top-[5px] right-[5px] p-[5px] text-[15px] leading-[15px]"
                                    onMouseOver={() => setModeInstructionPreview(mode)}
                                    onMouseOut={() => setModeInstructionPreview(undefined)}
                                />
                            )}
                        </div>
                    )
                })}
            </div>
            <div className="mt-[30px]">
                <ToolConfig />
            </div>
        </div>
    )
}

export default CutOutButtons
